import { render, staticRenderFns } from "./SegmentListCreateOrEditFiltersMatch.vue?vue&type=template&id=160d534b&"
import script from "./SegmentListCreateOrEditFiltersMatch.vue?vue&type=script&lang=js&"
export * from "./SegmentListCreateOrEditFiltersMatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports